<template>
  <div>
    <v-dialog fullscreen hide-overlay transition="dialog-top-transition" v-model="dialog" :style="{ zIndex: 20001 }">
      <div style="position:absolute;left:0;right:0;top:0;bottom:0;background: rgba(255,255,255,0.8)"></div>
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('close')">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Cancel Meeting</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="send">
              Send
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list three-line subheader style="background:whitesmoke" scrollable>
          <div class="full-screen-loader" v-if="loader"><b-spinner></b-spinner></div>
          <div class="form_error" v-show="errorMessage && errorMessage.length > 0">
            <v-icon color="red darken-2">
              mdi-alert
            </v-icon>
            {{ errorMessage }}
          </div>
          <div class="d-flex">
            <v-col lg="6">
              <div class="block block-mode-loading-oneui">
                <v-subheader>EXPERT EMAIL</v-subheader>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <div class="form-group d-flex" style="align-items:center">
                      <label class="col-form-label col-1 font-size-sm me-1">To*</label>
                      <multiselect
                        v-model="toExperts"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search for expert or add email"
                        label="name"
                        track-by="email"
                        :options="experts"
                        :multiple="true"
                        :taggable="true"
                        @tag="addToExperts"
                      ></multiselect>
                      <b-dropdown id="dropdown-right" right text="Action" variant="primary" class="ms-2" style="color:white">
                        <b-dropdown-item href="#" @click.stop.prevent="clearExperts">Clear</b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop.prevent="addAllExperts">Add all</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="form-group d-flex" style="align-items:center">
                      <label class="col-form-label col-1 font-size-sm me-1">Cc</label>
                      <multiselect
                        v-model="ccExperts"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search for expert or add email"
                        label="name"
                        track-by="email"
                        :options="ccUsersComputed"
                        :multiple="true"
                        :taggable="true"
                        @tag="addCcExperts"
                      ></multiselect>
                      <b-dropdown id="dropdown-right" right text="Action" variant="primary" class="ms-2" style="color:white">
                        <b-dropdown-item href="#" @click.stop.prevent="clearExpertsCc">Clear</b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop.prevent="addAllExpertsCc">Add all</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="form-group d-flex" style="align-items:center">
                      <label class="col-form-label col-1 font-size-sm me-1">Bcc</label>
                      <multiselect
                        v-model="bccExperts"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search for expert or add email"
                        label="name"
                        track-by="email"
                        :options="bccUsers"
                        :multiple="true"
                        :taggable="true"
                        @tag="addBccExperts"
                      ></multiselect>
                      <b-dropdown id="dropdown-right" right text="Action" variant="primary" class="ms-2" style="color:white">
                        <b-dropdown-item href="#" @click.stop.prevent="clearExpertsBcc">Clear</b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop.prevent="addAllExpertsBcc">Add all</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label font-size-sm">Subject*</label>
                      <div class="col-sm-12">
                        <input type="text" v-model="subjectExperts" required="required" class="form-control form-control-sm" />
                      </div>
                    </div>
                    <wysiwyg v-model="expertHTML" />
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-col>
            <v-col lg="6">
              <div class="block block-mode-loading-oneui">
                <v-subheader>EXPERT EMAIL PREVIEW</v-subheader>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <div v-html="expertHTML"></div>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-col>
          </div>
          <!-- Client -->

          <div class="d-flex">
            <v-col lg="6">
              <div class="block block-mode-loading-oneui">
                <v-subheader>CLIENT EMAIL</v-subheader>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <div class="form-group d-flex" style="align-items:center">
                      <label class="col-form-label col-1 font-size-sm me-1">To*</label>
                      <multiselect
                        v-model="toClients"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search for expert or add email"
                        label="name"
                        track-by="email"
                        :options="clients"
                        :multiple="true"
                        :taggable="true"
                        @tag="addToClients"
                      ></multiselect>
                      <b-dropdown id="dropdown-right" right text="Action" variant="primary" class="ms-2" style="color:white">
                        <b-dropdown-item href="#" @click.stop.prevent="clearExperts">Clear</b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop.prevent="addAllExperts">Add all</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="form-group d-flex" style="align-items:center">
                      <label class="col-form-label col-1 font-size-sm me-1">Cc</label>
                      <multiselect
                        v-model="ccClients"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search for expert or add email"
                        label="name"
                        track-by="email"
                        :options="ccUsersComputed"
                        :multiple="true"
                        :taggable="true"
                        @tag="addCcClients"
                      ></multiselect>
                      <b-dropdown id="dropdown-right" right text="Action" variant="primary" class="ms-2" style="color:white">
                        <b-dropdown-item href="#" @click.stop.prevent="clearExpertsCc">Clear</b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop.prevent="addAllExpertsCc">Add all</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="form-group d-flex" style="align-items:center">
                      <label class="col-form-label col-1 font-size-sm me-1">Bcc</label>
                      <multiselect
                        v-model="bccClients"
                        tag-placeholder="Add this as new tag"
                        placeholder="Search for expert or add email"
                        label="name"
                        track-by="email"
                        :options="bccUsers"
                        :multiple="true"
                        :taggable="true"
                        @tag="addBccClients"
                      ></multiselect>
                      <b-dropdown id="dropdown-right" right text="Action" variant="primary" class="ms-2" style="color:white">
                        <b-dropdown-item href="#" @click.stop.prevent="clearExpertsBcc">Clear</b-dropdown-item>
                        <b-dropdown-item href="#" @click.stop.prevent="addAllExpertsBcc">Add all</b-dropdown-item>
                      </b-dropdown>
                    </div>
                    <div class="form-group">
                      <label class="col-sm-2 col-form-label font-size-sm">Subject*</label>
                      <div class="col-sm-12">
                        <input type="text" v-model="subjectClients" required="required" class="form-control form-control-sm" />
                      </div>
                    </div>
                    <wysiwyg v-model="clientHTML" />
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-col>
            <v-col lg="6">
              <div class="block block-mode-loading-oneui">
                <v-subheader>CLIENT EMAIL PREVIEW</v-subheader>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <div v-html="clientHTML"></div>
                  </v-list-item-content>
                </v-list-item>
              </div>
            </v-col>
          </div>
        </v-list>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  props: {
    eventid: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      dialog: true,
      notifications: false,
      sound: true,
      widgets: false,
      expertHTML: "<span>Loading... </span>",
      clientHTML: "<span>Loading... </span>",
      experts: [],
      toExperts: [],
      toExpertsSecondMail: [],
      ccExperts: [],
      bccExperts: [],
      ccUsers: [],
      bccUsers: [],
      toClients: [],
      ccClients: [],
      bccClients: [],
      clients: [],
      loader: true,
      subjectExperts: "",
      subjectClients: "",
      errorMessage: "",
      me: {},
      project: {},
    };
  },
  computed: {
    ccUsersComputed() {
      const r = this.ccUsers.filter(v => v.email !== this.me.email);
      console.log(this.ccUsers);
      return r || [];
    },
    projectComputed() {
      return this.project || {};
    },
  },
  mounted() {
    this.getMySelf().then(v => this.getContent());
  },
  methods: {
    async getContent() {
      try {
        const response = await axios.get(`/admin/email/online-meeting-cancelation/preview/${this.eventid}`);
        let firstExpertName = null;
        let firstClientName = null;
        this.project = response.data.project;
        response.data.experts.forEach((v, i) => {
          if (v.user) {
            const exp = {
              expert_id: v.id,
              email: v.user.email,
              user_id: v.user_id,
              name: `${v.user.first_name} ${v.user.last_name}`,
            };
            if (!firstExpertName) {
              firstExpertName = v.user.first_name;
            }
            this.$set(this.experts, i, exp);
            this.$set(this.toExperts, i, exp);

            if(v.user.email_2 !== null) {
                this.$set(this.toExpertsSecondMail, i, {
                    expert_id: v.id,
                    email: v.user.email_2,
                    user_id: v.user_id,
                    name: `${v.user.first_name} ${v.user.last_name}`,
                })
            }
          }
        });

        response.data.clients.forEach((v, i) => {
          if (v.user) {
            const client = {
              clients_id: v.id,
              email: v.user.email,
              user_id: v.user_id,
              name: `${v.user.first_name} ${v.user.last_name}`,
            };
            if (!firstClientName) {
              firstClientName = v.user.first_name;
            }
            this.$set(this.clients, i, client);
            this.$set(this.toClients, i, client);
          }
        });

        let i = 0;
        response.data.staffs.forEach(v => {
            const exp = {
              staff_id: v.id,
              email: v.user.email,
              user_id: v.user_id,
              name: `${v.user.first_name} ${v.user.last_name}`,
            };
            this.$set(this.ccUsers, i, exp);
            this.$set(this.ccClients, i, exp);
            this.$set(this.ccExperts, i, exp);
            i++;
        });

        try {
          this.subjectExperts = `Nodes Meeting Cancellation: ${response.data.event.assignment.project.project_title} (${firstExpertName})`;
          this.subjectClients = `Nodes Meeting Cancellation: ${response.data.event.assignment.project.project_title} (${firstClientName})`;
        } catch (e) {}
        this.loader = false;
        this.expertHTML = response.data.expert_body;
        this.clientHTML = response.data.client_body;
      } catch (e) {
        if (e.response && e.response.data) {
            One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: e.response.data.error});
        } else {
            One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: 'An unknown error has occured'});
        }
        setTimeout(() => {
          this.$emit("close");
        }, 600);
      }
    },
    async getMySelf() {
      const response = await axios.get(`/admin/me`);
      this.me = {
        email: response.data.email,
        user_id: response.data.id,
        name: `${response.data.first_name} ${response.data.last_name}`,
      };
      //this.$set(this.ccUsers, 0, exp);
      /*this.$set(this.bccExperts, 0, this.me);
      this.$set(this.bccClients, 0, this.me);
      this.$set(this.bccUsers, 0, this.me);*/
      return 1;
    },
    clearExperts() {
      this.to = [];
    },
    addAllExperts() {
      this.to = [...this.experts];
    },
    addToExperts(newEmail) {
      const tag = {
        name: newEmail,
        email: newEmail,
      };
      this.experts.push(tag);
      this.toExperts.push(tag);
    },
    addToClients(newEmail) {
      const tag = {
        name: newEmail,
        email: newEmail,
      };
      this.clients.push(tag);
      this.toClients.push(tag);
    },
    addCcExperts(newEmail) {
      const tag = {
        name: newEmail,
        email: newEmail,
      };
      this.ccUsers.push(tag);
      this.ccExperts.push(tag);
    },
    addBccExperts(newEmail) {
      const tag = {
        name: newEmail,
        email: newEmail,
      };
      this.bccUsers.push(tag);
      this.bccExperts.push(tag);
    },
    addCcClients(newEmail) {
      const tag = {
        name: newEmail,
        email: newEmail,
      };
      this.ccUsers.push(tag);
      this.ccClients.push(tag);
    },
    addBccClients(newEmail) {
      const tag = {
        name: newEmail,
        email: newEmail,
      };
      this.bccUsers.push(tag);
      this.bccClients.push(tag);
    },
    verifyData() {
      this.errorMessage = "";
      const checkNoEmpty = [this.toExperts, this.toClients, this.subjectExperts, this.subjectClients];
      const len = checkNoEmpty.length;
      for (let i; i < checkNoEmpty; i++) {
        if (checkNoEmpty[i].length === 0) {
          this.errorMessage = "Please fill up all the fields";
          return false;
        }
      }
      return true;
    },
    async realSend() {
      this.errorMessage = "";
      this.loader = true;
      const url = `/admin/email/online-meeting-cancelation/send/${this.eventid}`;
      try {
        const response = await axios.post(url, {
          eventId: this.eventid,
          subjectExperts: this.subjectExperts,
          bodyExperts: this.expertHTML,
          toExperts: this.toExperts,
          toExpertsSecondMail: this.toExpertsSecondMail,
          ccExperts: this.ccExperts,
          bccExperts: this.bccExperts,
          expertFiles: null,
          subjectClients: this.subjectClients,
          bodyClients: this.clientHTML,
          toClients: this.toClients,
          ccClients: this.ccClients,
          bccClients: this.bccClients,
          clientFiles: null,
        });
        if (response.data.status === "OK") {
          setTimeout(() => {
              One.helpers('jq-notify', {type: 'success', icon: 'fa fa-check me-1', message: 'Cancellation email has been sent!'});
            this.$emit("close");
          }, 600);
          this.$emit("deleted", this.eventid);
        } else {
          this.errorMessage = response.data.error;
        }

        this.loader = false;
      } catch (e) {
        this.loader = false;
        if (e.response && e.response.data) this.errorMessage = e.response.data.message;
        console.log(e);
      }
    },
    send() {
      if (this.verifyData()) {
        this.realSend();
      }
    },
  },
};
</script>
<style lang="scss">
.form_error {
  border: red 1px solid;
  padding: 10px 20px;
  margin: 4px 10px;
  color: red;
  .v-icon {
    color: red;
  }
}
</style>
